/**
 * Соответствие path → org-модуль для гейтов embed (согласовано с ClientProtectedOutlet / шапкой).
 * Бэкенд для `GET /api/v1/schedule/slots` и карточки слота проверяет модуль `schedule` у организации.
 */
export function requiredClientModuleByPath(pathname: string): string | null {
  if (pathname.startsWith('/sessions/')) return 'schedule';
  if (pathname.startsWith('/bookings')) return null;
  if (pathname === '/schedule' || pathname.startsWith('/schedule/')) return null;
  if (pathname === '/book' || pathname.startsWith('/book/')) return null;
  if (pathname === '/services' || pathname.startsWith('/services/')) return null;
  if (pathname.startsWith('/fitness')) return 'fitness';
  if (pathname.startsWith('/trainers')) return 'fitness';
  if (pathname.startsWith('/pay/')) return 'payments';
  if (pathname.startsWith('/subscription-plans')) return 'subscriptions';
  if (pathname.startsWith('/my-subscriptions')) return 'subscriptions';
  if (pathname === '/my-access' || pathname.startsWith('/my-access')) return 'qrcode';
  return null;
}

/** Все экраны `/trainer/*` — сценарий тренера; API фитнеса и staff-тренерские проверки завязаны на модуль `fitness`. Запросы расписания на бэкенде дополнительно требуют модуль `schedule` (`requireScheduleModuleForOrg`). */
export function requiredTrainerModuleByPath(pathname: string): string | null {
  if (pathname === '/trainer' || pathname.startsWith('/trainer/')) return 'fitness';
  return null;
}

/**
 * Показывать ли пункт навигации на экран `pathname` при модулях организации `modules`.
 * Если модули ещё не известны (гость, загрузка), решает `whenUnknown`.
 */
export function isClientPathEnabledByModules(
  pathname: string,
  modules: Record<string, boolean> | null | undefined,
  whenUnknown: boolean
): boolean {
  const req = requiredClientModuleByPath(pathname);
  if (req == null) return true;
  if (!modules) return whenUnknown;
  return modules[req] === true;
}
